import * as z from "zod";

/** Shared between the RPC handler that signs the OAuth state and the callback that verifies it. */
export const AMAZON_SHIPPING_OAUTH_PURPOSE = "amazonShipping" as const;

export const getAmazonShippingAuthUrl = {
  name: "getAmazonShippingAuthUrl" as const,
  input: z.object({ replacesCarrierAccountId: z.string().optional() }),
  output: z.object({ authUrl: z.string() }),
};
